
// jsmini engine - tree-walking
export { tokenize } from "../src/lexer/lexer.ts";
export { parse } from "../src/parser/parser.ts";
export { evaluate } from "../src/interpreter/evaluator.ts";

// jsmini engine - bytecode VM
export { vmEvaluate } from "../src/vm/index.ts";
export { compile } from "../src/vm/compiler.ts";
export { disassemble } from "../src/vm/bytecode.ts";

// jsmini engine - Wasm JIT
export { disassembleToWat } from "../src/jit/wasm-compiler.ts";

// jsmini engine - IR
export { buildIR } from "../src/ir/builder.ts";
export { printIR } from "../src/ir/printer.ts";
export { optimize } from "../src/ir/optimize.ts";
export { codegenIR } from "../src/ir/codegen.ts";

// CodeMirror
export { basicSetup } from "codemirror";
export { javascript } from "@codemirror/lang-javascript";
export { oneDark } from "@codemirror/theme-one-dark";
export { EditorView, keymap, Decoration } from "@codemirror/view";
export { Prec, StateEffect, StateField, RangeSet } from "@codemirror/state";
